import axios from "axios";
import Config from "../config";
import qs from "qs";
import EventBus from "../components/Ui/EventBus";

let lastValidationTime = null;
let cacheDuration = 60 * 60 * 1000; // 1 saat (milisaniye cinsinden)

function isValidationRequired() {
  return !lastValidationTime || Date.now() - lastValidationTime > cacheDuration;
}

function setLastValidationTime() {
  lastValidationTime = Date.now();
}

function authHeaders() {
  return { headers: { Authorization: localStorage.authToken } };
}

export default {
  login(data) {
    return axios.post(Config.endpoint + "/auth/login", qs.stringify(data));
  },

  logout() {
    localStorage.removeItem("authToken");
  },

  // Sunucuda yapılandırılmış dış giriş sağlayıcıları (ör. Viqqa). Boş liste
  // dönerse giriş ekranında ek buton gösterilmez.
  providers() {
    return axios.get(Config.endpoint + "/auth/providers");
  },

  // "Viqqa ile giriş yap": { success, url } döner, tarayıcı url'e yönlendirilir.
  viqqaStart() {
    return axios.post(Config.endpoint + "/auth/viqqa/start");
  },

  // Oturum açıkken Viqqa hesabını bağlama akışını başlatır.
  viqqaLinkStart() {
    return axios.post(
      Config.endpoint + "/auth/viqqa/link/start",
      null,
      authHeaders()
    );
  },

  // Viqqa'dan dönen code/state'i API'ye iletir: { token } (giriş) ya da { linked } (bağlama).
  viqqaCallback(code, state) {
    return axios.post(
      Config.endpoint + "/auth/viqqa/callback",
      qs.stringify({ code, state })
    );
  },

  viqqaStatus() {
    return axios.get(Config.endpoint + "/auth/viqqa/status", authHeaders());
  },

  viqqaUnlink() {
    return axios.delete(Config.endpoint + "/auth/viqqa/link", authHeaders());
  },

  loginValidate() {
    if (!isValidationRequired()) {
      return Promise.resolve(true);
    }

    axios.defaults.headers.common["Authorization"] = localStorage.authToken;

    return axios.post(Config.endpoint + "/auth/validate").then((resp) => {
      if (resp.data.success === true) {
        localStorage.setItem("userName", resp.data.data.userName);
        localStorage.setItem("userId", resp.data.data.userId);
        localStorage.setItem("telegram_id", resp.data.data.telegram_id);
        localStorage.setItem("theme", resp.data.data.theme);
        localStorage.setItem("dahili", resp.data.data.dahili);
        if(resp.data.data.passwordFirst == true){
 
          alert("Standart şifre ile giriş yaptınız, şifrenizi değiştirmeniz gerekmektedir.");
          if(window.location.pathname == '/profile'){
          
          }
          else {
            window.location.href = '/profile';
          }
        
        }

        EventBus.$emit("userName", resp.data.data.userName);

        


        setLastValidationTime();

        return true;
      }
      return false;
    });
  },
};
